import { GridItem, Stack } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { AnimatedNumber, FadeIn, Text } from "@/features/greenEnergy"
import { type SbBlokGreenEnergyDistributed } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyDistributed
}

export function DynamicEnergyDistributed({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 1, xl: 1 }}
            gridColumnStart={{ base: 1, xl: 1 }}
            gridRowEnd={{ base: 2, xl: 2 }}
            gridColumnEnd={{ base: 3, xl: 3 }}
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Stack
                    flexDirection="column"
                    alignItems={{ base: undefined, xl: "flex-end" }}
                    gap="xs"
                >
                    <Stack
                        flexDirection="column"
                        gap="none"
                    >
                        <Text>{blok.line1}</Text>
                        <Text>{blok.line2}</Text>
                    </Stack>
                    <Stack alignItems="flex-end">
                        <AnimatedNumber
                            target={blok.amount}
                            final={blok.amount}
                        />
                        <Text showcased>{blok.unit}</Text>
                    </Stack>
                </Stack>
            </FadeIn>
        </GridItem>
    )
}

export default DynamicEnergyDistributed
